/**
 * 银行审核接口的service
 */

import { post } from '@/request/http';

const Calculation = {
  // 获取初审结果通知
  calculationCode(params) {
    return post('/backloansuper/loan/supermarket/smsWithLogin/v1.0', params);
  },
  subUserInfoData(params) {
    return post('/backloansuper/loan/supermarket/test/insertLoanTestInfo', params);
  },
};

export default Calculation;
